import { Slider, styled } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

const StyledSlider = styled(Slider)(({ theme }) => ({
    color: "#FAFAFA", //color of the slider between thumbs
    paddingBottom: "0px",
    paddingTop: "0px",
    [theme.breakpoints.up("lg")]: {
        paddingBottom: "6px",
        paddingTop: "6px",
    },
    "& .MuiSlider-thumb": {
        backgroundColor: "#0093D1",
        height: "16px",
        width: "16px",
        transition: "none",
    },
    "& .MuiSlider-rail": {
        borderRadius: "4.5px",
        backgroundColor: "#FAFAFA",
        boxShadow: "inset 1px 1px 1px 1px rgba(0,0,0,0.19)",
    },
    "& .MuiSlider-track": {
        width: "0px !important",
        border: "0px",
    },
}));

export const MIN_AMOUNT_NEW_MORTGAGE = 100000; // defined from the business

const MortgageSlider = (props: {
    min: number;
    max: number;
    sliderStep: number;
    onSliderChange: Function;
    value: number;
    selector: string;
}) => {
    const { min, max, sliderStep, onSliderChange, value, selector } = props;

    function handleSliderChange(event: Event, newValue: number | number[]) {
        if (typeof newValue === "number") {
            onSliderChange(newValue);
        }
    }

    return (
        <Box>
            <StyledSlider
                data-cy={selector}
                min={min}
                max={max}
                value={value}
                step={sliderStep}
                onChange={handleSliderChange}
            />
        </Box>
    );
};

export default MortgageSlider;
